module.exports = __webpack_public_path__ + "img/dakoda_camp.45d3ba67.jpg";